import { useState } from 'react';
import { Link } from 'react-router-dom';
import { LogoMarque } from '../marque/LogoMarque';
import { appelApi, ErreurApi } from '../lib/api';
import { useTitrePage } from '../lib/useTitrePage';

export function MotDePasseOubliePage(): JSX.Element {
  useTitrePage('Mot de passe oublié');
  const [email, setEmail] = useState('');
  const [erreur, setErreur] = useState<string | null>(null);
  const [succes, setSucces] = useState(false);
  const [enCours, setEnCours] = useState(false);

  async function soumettre(evenement: React.FormEvent): Promise<void> {
    evenement.preventDefault();
    setErreur(null);
    setEnCours(true);
    try {
      await appelApi('/auth/oubli', {
        methode: 'POST',
        corps: { email },
      });
      setSucces(true);
    } catch (cause) {
      setErreur(
        cause instanceof ErreurApi
          ? cause.message
          : 'Envoi impossible. Vérifiez votre accès au réseau.',
      );
    } finally {
      setEnCours(false);
    }
  }

  return (
    <div className="login-bg flex min-h-screen items-center justify-center p-4 sm:p-6">
      <div className="w-full max-w-md rounded-3xl bg-white p-4 sm:p-8 shadow-2xl lg:p-10">
        <div className="mb-8 flex items-center justify-center">
          <LogoMarque className="h-10 w-auto" />
        </div>

        <div className="mb-8 text-center">
          <h1 className="font-display text-2xl font-bold text-codialis-navy">Mot de passe oublié</h1>
          <p className="mt-2 text-sm text-codialis-gray">
            Entrez votre adresse e-mail pour recevoir un lien de réinitialisation.
          </p>
        </div>

        {succes ? (
          <div className="space-y-6 text-center">
            <div className="rounded-xl bg-green-50 p-4 text-sm text-green-800">
              Si un compte est associé à cette adresse, un e-mail vient de vous être envoyé avec les instructions.
            </div>
            <Link
              to="/login"
              className="inline-block text-sm font-medium text-codialis-sky hover:underline"
            >
              Retour à la connexion
            </Link>
          </div>
        ) : (
          <form onSubmit={soumettre} className="space-y-6" noValidate>
            <div>
              <label
                htmlFor="email"
                className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-codialis-navy"
              >
                Adresse e-mail
              </label>
              <input
                id="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-3 text-sm focus:border-transparent focus:outline-none focus:ring-2 focus:ring-codialis-mint"
              />
            </div>

            {erreur && (
              <div
                role="alert"
                className="rounded-xl border border-red-100 bg-red-50 px-4 py-3 text-sm text-red-700"
              >
                {erreur}
              </div>
            )}

            <button
              type="submit"
              disabled={enCours || !email}
              className="flex w-full items-center justify-center gap-2 rounded-xl bg-codialis-navy py-3.5 font-semibold text-white transition hover:bg-codialis-deep disabled:cursor-not-allowed disabled:opacity-60"
            >
              {enCours ? 'Envoi en cours…' : 'Envoyer le lien'}
            </button>

            <div className="text-center text-sm">
              <Link to="/login" className="text-codialis-sky hover:underline">
                Retour à la connexion
              </Link>
            </div>
          </form>
        )}
      </div>
    </div>
  );
}
